import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { enterPrisesPaths } from "../../routes/enterprises";
import { curSym } from "../../utils/pip";
import { fetchPostJobs } from "../../redux/features/find-a-job/actions/authAction";

const Freelance = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { isLoading, freelancersJobs } = useSelector(state => state.freelancer.auth)

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
    dispatch(fetchPostJobs());
  }, []);


  const displayJobs = freelancersJobs?.filter((item) => {
    return item;
  });

  const featuredJobIcons = [
    "../assets/img/Featured_Jobs_icon_1.svg",
    "../assets/img/Featured_Jobs_icon_2.svg",
    "../assets/img/Featured_Jobs_icon_3.svg",
    "../assets/img/Featured_Jobs_icon_4.svg",
    "../assets/img/Featured_Jobs_icon_5.svg",
  ];

  const formatSalary = (job) => {
    const currency = job?.salary_currency || "INR";
    const minSalary = Number(job?.min_salary);
    const maxSalary = Number(job?.max_salary);

    if (!minSalary && !maxSalary) {
      return "Salary not disclosed";
    }

    const formatAmount = (amount) =>
      new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      }).format(amount);

    if (minSalary && maxSalary) {
      return `${formatAmount(minSalary)} - ${formatAmount(maxSalary)}`;
    }

    return formatAmount(minSalary || maxSalary);
  };

  const formatExperience = (yearsOfExperience) => {
    if (!yearsOfExperience) {
      return "Experience not specified";
    }

    return `${yearsOfExperience} year${Number(yearsOfExperience) > 1 ? "s" : ""}`;
  };

  if (isLoading || isLoading2) {
    return <Loader />;
  };
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section class="ct_px_40    py-5">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-md-12  mb-4 mb-md-0 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div class="ct_px_40 ct_px_0_767 text-center">
                    <h2
                      class="ct_fs_50_new mb-4 mx-auto "
                      style={{ maxWidth: "1056px" }}
                    >
                      Launch Your IT Freelance Career with{" "}
                      <span class="ct_yellow_text"> Confidence </span>and
                      Clarity.
                    </h2>
                    <p
                      class="mb-0 mt-3 ct_fs_20 mx-auto"
                      style={{ maxWidth: "800px" }}
                    >
                      NUVIO bridges the gap between skilled IT professionals and
                      businesses that need them. From beginners to experience
                      experts, we’ve got tailored opportunities just for you.
                    </p>
                    <div class="ct_mt_30 d-flex align-items-center justify-content-center gap-4 ct_flex_col_575">
                      <a
                        class="ct_yellow_btn   px-5 ct_fit_content ct_h_48 ct_w_100_575"
                      // onClick={() => navigate(coachPaths?.find_job)}
                      // navigate(coachPaths.ContactUs, { state: { data: "landing" } })
                      >
                        Explore Jobs
                      </a>

                      <a
                        onClick={openSignUp}
                        class="ct_yellow_btn ct_outline_yellow_new  px-5 ct_fit_content ct_h_48 ct_w_100_575"
                      >
                        Get Started
                      </a>
                    </div>
                  </div>

                  <div className="row ct_mt_30">
                    <div className="col-sm-6 mb-4">
                      <div className="ct_aspect_ratio_for_486_res">
                        <img
                          src="../assets/img/freelance_banner_img_1.png"
                          className="ct_img_h_486"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 mb-4">
                      <div className="ct_aspect_ratio_for_486_res">
                        <img
                          src="../assets/img/freelance_banner_img_2.png"
                          className="ct_img_h_486"
                        />
                      </div>
                    </div>
                  </div>

                  <ul className="ct_freelance_banner_count ct_flex_col_575">
                    <li className="d-flex align-items-center gap-3 flex-wrap ">
                      <span className="ct_fs_48 ct_white_nowrap">1M+</span>
                      <span className="ct_fs_17" style={{ maxWidth: "187px" }}>
                        Customers visit Nuvio every months
                      </span>
                    </li>
                    <li className="d-flex align-items-center gap-3 flex-wrap">
                      <span className="ct_fs_48 ct_white_nowrap">93%</span>
                      <span className="ct_fs_17" style={{ maxWidth: "187px" }}>
                        Satisfaction rate from our customers.
                      </span>
                    </li>
                    <li className="d-flex align-items-center gap-3 flex-wrap">
                      <span className="ct_fs_48 ct_white_nowrap">4.9</span>
                      <span className="ct_fs_17" style={{ maxWidth: "187px" }}>
                        Average customer ratings out of 5.00!
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <div className="ct_border_top_light ">
            <section
              className="ct_px_40 ct_py_55 ct_mt_30"
              style={{ backgroundColor: "#219EBC" }}
            >
              <div className="container-fluid">
                <div className="row align-items-end">
                  <div
                    className="col-xxl-4 col-xl-4 mb-4 mb-xl-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div className="">
                      <h4 className="ct_fs_32 mb-2 text-white text-center text-xl-start">
                        Google Ads Goes Here
                      </h4>
                      <p
                        className="ct_fs_18 text-white mb-0 mx-auto mx-xl-0"
                        style={{ maxWidth: "379px" }}
                      >
                        Start your journey with our top free companies with your
                        personal branding in check
                      </p>
                      <div className="ct_mt_30 ">
                        <button className="ct_yellow_btn ct_darkblue_btn px-5 mx-auto mx-xl-0">
                          Learn More
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xxl-8 col-xl-8 mb-4 mb-xl-0"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div className="d-flex align-items-center justify-lg-content-end justify-content-center gap-3 ga-md-5">
                      <div className="px-3">
                        <img
                          src="../assets/img/google_ads_1.png"
                          className="w-100"
                        />
                      </div>
                      <div className="px-3">
                        <img
                          src="../assets/img/google_ads_2.png"
                          className="w-100"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="ct_sky_blue_bg ct_py_80 ct_px_40">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="ct_fs_32 ct_pb_60  text-center mb-0 ct_darkblue_text">
                      Create, Connect, and Grow with NuCore
                    </h2>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="1000"
                  >
                    <h4 class="ct_yellow_text  ct_fs_35 mb-3">NuGlow</h4>

                    <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                      <div
                        class="ct_coach_created_img ct_coach_aspect_14_9_res_991 "
                        style={{ aspectRatio: "auto" }}
                      >
                        <img
                          alt=""
                          src="/../assets/img/create_img_1.png"
                          className="ct_img_h_267"
                        />
                      </div>
                      <figcaption class="mt-3">
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                          style={{ maxWidth: "366px" }}
                        >
                          Start your freelance journey. Build your profile, gain
                          experience, and grow your skills.
                        </p>
                        <div className="mt-3">
                          <a
                            class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                            style={{
                              color: "var(--dark_blue)",
                              borderColor: "var(--dark_blue)",
                            }}
                            onClick={() =>
                              navigate(coachPaths?.NuGlowSubscription)
                            }
                          >
                            Get Started{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                  >
                    <h4 class="ct_orange_text  ct_fs_32 mb-3">NuForge</h4>

                    <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                      <div
                        class="ct_coach_created_img ct_coach_aspect_14_9_res_991"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img
                          alt=""
                          src="/../assets/img/create_img_2.png"
                          className="ct_img_h_267"
                        />
                      </div>
                      <figcaption class="mt-3">
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                          style={{ maxWidth: "366px" }}
                        >
                          Take your career to the next level. Work on high-value
                          projects and expand your network.
                        </p>
                        <div className="mt-3">
                          <a
                            class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                            style={{
                              color: "var(--dark_blue)",
                              borderColor: "var(--dark_blue)",
                            }}
                            onClick={() =>
                              navigate(coachPaths?.NuForgeSubscription)
                            }
                          >
                            Get Started{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="2000"
                  >
                    <h4 class="ct_darksky_blue_text  ct_fs_32 mb-3">NuStar</h4>

                    <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                      <div
                        class="ct_coach_created_img ct_coach_aspect_14_9_res_991"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img
                          alt=""
                          src="/../assets/img/create_img_3.png"
                          className="ct_img_h_267"
                        />
                      </div>
                      <figcaption class="mt-3">
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                          style={{ maxWidth: "366px" }}
                        >
                          Lead as a top-tier freelancer. Access premium
                          opportunities and elevate your personal brand.
                        </p>
                        <div className="mt-3">
                          <a
                            class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                            style={{
                              color: "var(--dark_blue)",
                              borderColor: "var(--dark_blue)",
                            }}
                            onClick={() =>
                              navigate(coachPaths?.NuStarSubscription)
                            }
                          >
                            Get Started{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </section>

            <section className="ct_pt_130 ct_px_40 ct_pb_135">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="ct_fs_32 text-center ct_mb_60">
                      Featured Jobs
                    </h2>
                  </div>
                </div>
                {displayJobs?.length ? (
                  <div className="row">
                    {displayJobs.map((job, index) => (
                      <div
                        key={job?.id || index}
                        onClick={() =>
                          navigate(coachPaths?.FullJob, {
                            state: {
                              data: job,
                              jobList: displayJobs,
                              index,
                            },
                          })
                        }
                        className="col-xxl-6 col-xl-6 mb-5"
                        data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                        data-aos-duration="1500"
                      >
                        <div className="ct_feature_job_card">
                          <div className="ct_feature_job_icon">
                            <img
                              src={job?.company_image || "../assets/img/Featured_Jobs_icon_1.svg"}
                              alt={job?.company_name || "Featured job"}
                            />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-4 ct_mb_20 flex-wrap">
                              <span
                                className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{ backgroundColor: "var(--yellow)" }}
                              >
                                {job?.candidate_availability || "Not specified"}
                              </span>
                              <span
                                className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                                style={{ backgroundColor: "var(--dark_blue)" }}
                              >
                                {job?.category || job?.industry || "General"}
                              </span>
                            </div>
                            <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                              {job?.job_title || "Untitled job"}
                            </h4>
                            <ul className="ct_feature_job_key_points">
                              <li>
                                <i className="fa-solid fa-briefcase ct_darkblue_text"></i>
                                <span className="ct_darkblue_text">
                                  {formatExperience(job?.years_of_experience)}
                                </span>
                              </li>
                              <li>
                                <i className="fa-solid fa-wallet ct_darkblue_text"></i>
                                <span className="ct_darkblue_text">
                                  {formatSalary(job)}
                                </span>
                              </li>
                              <li>
                                <i className="fa-solid fa-location-dot ct_darkblue_text"></i>
                                <span className="ct_darkblue_text">
                                  {job?.location || job?.candidate_location || "Location not specified"}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
                {!displayJobs?.length && (
                  <div className="row">
                    <div
                      onClick={() => navigate(coachPaths?.FullJob)}
                      className="col-xxl-6  col-xl-6  mb-5"
                      data-aos="fade-right"
                      data-aos-duration="1500"
                    >
                      <div className="ct_feature_job_card">
                        <div className="ct_feature_job_icon">
                          <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-4 ct_mb_20">
                            <span
                              className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{ backgroundColor: "var(--yellow)" }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                              style={{ backgroundColor: "var(--dark_blue)" }}
                            >
                              Website Development
                            </span>
                          </div>
                          <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                            Senior full stack engineer, User onboarding
                          </h4>
                          <ul className="ct_feature_job_key_points">
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">3-5 years</span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                {curSym} 5k to {curSym} 6k USD
                              </span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                London, England
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xxl-6  col-xl-6  mb-5"
                      data-aos="fade-left"
                      data-aos-duration="1500"
                      onClick={() => navigate(coachPaths?.FullJob)}
                    >
                      <div className="ct_feature_job_card">
                        <div className="ct_feature_job_icon">
                          <img src="../assets/img/Featured_Jobs_icon_2.svg" />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-4 ct_mb_20">
                            <span
                              className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{ backgroundColor: "var(--yellow)" }}
                            >
                              Part-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                              style={{ backgroundColor: "var(--dark_blue)" }}
                            >
                              UI/UX Design
                            </span>
                          </div>
                          <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                            Junior UX designer
                          </h4>
                          <ul className="ct_feature_job_key_points">
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">3-5 years</span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                {curSym} 5k to {curSym} 6k USD
                              </span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                London, England
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xxl-6  col-xl-6  mb-5"
                      data-aos="fade-right"
                      data-aos-duration="1500"
                      onClick={() => navigate(coachPaths?.FullJob)}
                    >
                      <div className="ct_feature_job_card">
                        <div className="ct_feature_job_icon">
                          <img src="../assets/img/Featured_Jobs_icon_3.svg" />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-4 ct_mb_20">
                            <span
                              className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{ backgroundColor: "var(--yellow)" }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                              style={{ backgroundColor: "var(--dark_blue)" }}
                            >
                              Mobile Development
                            </span>
                          </div>
                          <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                            Junior mobile app developer
                          </h4>
                          <ul className="ct_feature_job_key_points">
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">3-5 years</span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                {curSym} 5k to {curSym} 6k USD
                              </span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                London, England
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xxl-6  col-xl-6  mb-5"
                      data-aos="fade-left"
                      data-aos-duration="1500"
                      onClick={() => navigate(coachPaths?.FullJob)}
                    >
                      <div className="ct_feature_job_card">
                        <div className="ct_feature_job_icon">
                          <img src="../assets/img/Featured_Jobs_icon_4.svg" />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-4 ct_mb_20">
                            <span
                              className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{ backgroundColor: "var(--yellow)" }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                              style={{ backgroundColor: "var(--dark_blue)" }}
                            >
                              UI/UX Design
                            </span>
                          </div>
                          <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                            Lead product designer, Fintech App
                          </h4>
                          <ul className="ct_feature_job_key_points">
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">3-5 years</span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                {curSym} 5k to {curSym} 6k USD
                              </span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                London, England
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xxl-6  col-xl-6  mb-5"
                      data-aos="fade-right"
                      data-aos-duration="1500"
                      onClick={() => navigate(coachPaths?.FullJob)}
                    >
                      <div className="ct_feature_job_card">
                        <div className="ct_feature_job_icon">
                          <img src="../assets/img/Featured_Jobs_icon_5.svg" />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-4 ct_mb_20">
                            <span
                              className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{ backgroundColor: "var(--yellow)" }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                              style={{ backgroundColor: "var(--dark_blue)" }}
                            >
                              UI/UX Design
                            </span>
                          </div>
                          <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                            UX Researcher , Health Tech Solutions
                          </h4>
                          <ul className="ct_feature_job_key_points">
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">3-5 years</span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                {curSym} 5k to {curSym} 6k USD
                              </span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                London, England
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xxl-6  col-xl-6  mb-5"
                      data-aos="fade-left"
                      data-aos-duration="1500"
                      onClick={() => navigate(coachPaths?.FullJob)}
                    >
                      <div className="ct_feature_job_card">
                        <div className="ct_feature_job_icon">
                          <img src="../assets/img/Featured_Jobs_icon_6.svg" />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-4 ct_mb_20">
                            <span
                              className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{ backgroundColor: "var(--yellow)" }}
                            >
                              Part-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                              style={{ backgroundColor: "var(--dark_blue)" }}
                            >
                              Content Writing
                            </span>
                          </div>
                          <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                            Content writer, Amazon
                          </h4>
                          <ul className="ct_feature_job_key_points">
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">3-5 years</span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                {curSym} 5k to {curSym} 6k USD
                              </span>
                            </li>
                            <li>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                                  fill="#023047"
                                />
                              </svg>
                              <span className="ct_darkblue_text">
                                London, England
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>

            <section className="ct_dark_blue_bg rounded-0 ct_py ct_search_dream_job_main">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="ct_fs_32 ct_mb_30 text-white">
                      Search Your Dream Job
                    </h4>
                    <div
                      className="ct_search_dream_job_filter ct_flex_col_991"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div className="form-group position-relative">
                        <select className="form-control ct_input ct_input_ps_40 ct_h_48 ct_blue_input_bg">
                          <option>Browse by</option>
                          <option>UI/UX Design</option>
                          <option>Mobile App Development</option>
                          <option>Web Development</option>
                          <option>Copy Writing</option>
                          <option>SEO Writing</option>
                          <option>Digital Marketing</option>
                          <option>Social Media Management</option>
                          <option>Product Management</option>
                          <option>Virtual Assistant</option>
                          <option>Customer</option>
                        </select>
                        <div className="ct_input_icon_left">
                          <svg
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.6158 9.49542C16.6158 13.4279 13.4279 16.6158 9.49542 16.6158C5.56293 16.6158 2.375 13.4279 2.375 9.49542C2.375 5.56293 5.56293 2.375 9.49542 2.375C13.4279 2.375 16.6158 5.56293 16.6158 9.49542Z"
                              stroke="#8ECAE6"
                              stroke-width="1.18674"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.5035 7.46023C13.0173 6.60401 13.2741 6.17589 13.1588 5.97463C13.1239 5.91359 13.0733 5.86298 13.0122 5.82802C12.811 5.71271 12.3829 5.96959 11.5267 6.48333L8.52716 8.28299C8.45969 8.32344 8.42602 8.34367 8.39724 8.36982C8.3876 8.37851 8.37848 8.38764 8.36986 8.3972C8.34364 8.42605 8.32348 8.45972 8.28295 8.5272L6.48333 11.5266C5.96958 12.3829 5.71272 12.8109 5.82801 13.0122C5.86298 13.0733 5.91358 13.1238 5.97462 13.1588C6.17588 13.2741 6.60401 13.0173 7.46027 12.5035L10.4597 10.7039C10.5271 10.6634 10.5609 10.6432 10.5897 10.6171C10.5992 10.6083 10.6084 10.5992 10.6171 10.5896C10.6431 10.5608 10.6634 10.5271 10.7039 10.4596L12.5035 7.46023ZM9.91254 9.91214C10.1443 9.68041 10.1443 9.30468 9.91254 9.07295C9.68082 8.84123 9.30508 8.84123 9.07336 9.07295C8.84163 9.30468 8.84163 9.68041 9.07336 9.91214C9.30508 10.1439 9.68082 10.1439 9.91254 9.91214Z"
                              fill="#8ECAE6"
                            />
                          </svg>
                        </div>
                      </div>
                      <div>
                        <h5 className="ct_fs_18 text-white ct_mb_20">
                          Most popular:
                        </h5>
                        <ul className="ct_most_popular_job_list">
                          <li>
                            <a onClick={() => navigate(enterPrisesPaths?.DesignService)}>UI/UX Design</a>
                          </li>
                          <li>
                            <a>Human Research</a>
                          </li>
                          <li>
                            <a onClick={() => navigate(enterPrisesPaths?.marketing_services)}>Digital Marketing</a>
                          </li>
                          <li>
                            <a>Video & Animation</a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="ct_mt_90">
                      <div className="d-flex align-items-center gap-3 justify-content-between ct_mb_40 ct_flex_col_575">
                        <h4 className="ct_fs_32 mb-0 text-white">
                          Recommended Opporturnity
                        </h4>
                        <a
                          className="ct_yellow_btn ct_sky_blue_btn ct_border_radius_8 ct_h_50 ct_white_nowrap"
                          onClick={() => navigate(coachPaths?.find_job)}
                        >
                          View All Jobs
                        </a>
                      </div>

                      <div className="row gx-xl-5">
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div className="ct_opportunity_card">
                            <img src="../assets/img/International_icon.svg" />
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                International
                              </h4>
                              <a
                                className="ct_light_blue_link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(coachPaths?.RecommendedOpporturnity, {
                                    state: { data: "International" },
                                  });
                                }}
                              >
                                View All{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div className="ct_opportunity_card">
                            <img src="../assets/img/Remote_icon.svg" />
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Remote
                              </h4>
                              <a className="ct_light_blue_link" onClick={(e) => {
                                e.preventDefault();
                                navigate(coachPaths?.RecommendedOpporturnity, {
                                  state: { data: "Remote" },
                                });
                              }}>
                                View All{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div className="ct_opportunity_card">
                            <img src="../assets/img/full_Time_icon.svg" />
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Full-Time
                              </h4>
                              <a className="ct_light_blue_link" onClick={(e) => {
                                e.preventDefault();
                                navigate(coachPaths?.RecommendedOpporturnity, {
                                  state: { data: "Full-Time" },
                                });
                              }}>
                                View All{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div className="ct_opportunity_card">
                            <img src="../assets/img/Part-Time_icon.svg" />
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Part-Time
                              </h4>
                              <a className="ct_light_blue_link" onClick={(e) => {
                                e.preventDefault();
                                navigate(coachPaths?.RecommendedOpporturnity, {
                                  state: { data: "Part-Time" },
                                });
                              }}>
                                View All{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="ct_pt_130 ct_px_40">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="ct_fs_32 text-center ct_darkblue_text ct_mb_60">
                      Why Be Part of NUVIO?
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-xxl-7 col-xl-7 col-lg-7 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div className="ct_py_56">
                      <h4 className="ct_fs_28 mb-3 ct_darkblue_text ct_text_op_8">
                        Career Growth with NUVIO
                      </h4>
                      <p
                        className="ct_fs_22 ct_line_h_40 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "676px" }}
                      >
                        At NUVIO, we’re committed to helping IT professionals
                        reach new heights through structured growth paths, real
                        opportunities, and the exposure needed to thrive in
                        today’s digital world.
                      </p>
                      <ul
                        className="ct_mt_20 ps-4 ct_para_scroll ct_custom_scroll"
                        style={{ listStyle: "disc" }}
                      >
                        <li className="ct_fs_22 ct_darkblue_text">
                          Start strong with NuGlow, NuForge & NuStar
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Land high-paying gigs from top clients
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Build skills, get reviews, and grow fast
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Level up with guided career support
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="col-xxl-5 col-xl-5 col-lg-5  ps-xl-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div className="py-4 ct_aspext_ratio_3_2_991">
                      <img
                        src="../assets/img/Why_Be_Part_of_NUVIO_right_img.png"
                        className="ct_img_h_592"
                      />
                    </div>
                  </div>
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div className="ct_minus_mt_40 py-4 ct_aspext_ratio_3_2_991">
                      <img
                        src="../assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                        className="ct_img_h_592"
                      />
                    </div>
                  </div>
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6  ps-xl-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div className="ct_py_56">
                      <h4 className="ct_fs_28 mb-3 ct_darkblue_text ct_text_op_8">
                        Work Flexibility & Community Support
                      </h4>
                      <p
                        className="ct_fs_22 ct_line_h_40 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "674px" }}
                      >
                        We believe in empowering our users to work freely while
                        staying supported and secure. Our platform is built to
                        give you confidence, and connection.
                      </p>
                      <ul
                        className="ct_mt_20 ps-4 ct_para_scroll ct_custom_scroll"
                        style={{ listStyle: "disc" }}
                      >
                        <li className="ct_fs_22 ct_darkblue_text">
                          Enjoy flexible work schedules that fit your lifestyle
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Get paid securely and on time with protections
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Join a network of like-minded IT professionals
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Receive ongoing support, feedback, and access to
                          curated resources
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="ct_px_40 ct_py_130 pb-0"
              data-aos="fade-down"
              data-aos-duration="1500"
            >
              <div className="container-fluid">
                {/* convert into slider */}
                <div className="row">
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div class="ct_testimonial_review_card h-100 d-grid">
                      <div>
                        <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          </div>
                          <p className="mb-0 ct_fs_16">20th April, 2025</p>
                        </div>
                        <p className="mb-0 " style={{ maxWidth: "295px" }}>
                          The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div class="d-flex align-items-center gap-3 ct_mt_40">
                          <img
                            src="/assets/img/Ellipse 24.png"
                            class="ct_img_60 "
                            alt=""
                          />
                          <div>
                            <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                              Alex Robertson
                            </h5>
                            <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div class="ct_testimonial_review_card h-100 d-grid">
                      <div>
                        <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          </div>

                          <p className="mb-0 ct_fs_16">20th April, 2025</p>
                        </div>
                        <p className="mb-0 " style={{ maxWidth: "295px" }}>
                          With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div class="d-flex align-items-center gap-3 ct_mt_40">
                          <img
                            src="/assets/img/Ellipse 24 (1).png"
                            class="ct_img_60 "
                            alt=""
                          />
                          <div>
                            <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                              Olivia Brooks
                            </h5>
                            <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div class="ct_testimonial_review_card h-100 d-grid">
                      <div>
                        <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          </div>

                          <p className="mb-0 ct_fs_16">20th April, 2025</p>
                        </div>
                        <p className="mb-0 " style={{ maxWidth: "295px" }}>
                          NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div class="d-flex align-items-center gap-3 ct_mt_40">
                          <img
                            src="/assets/img/Ellipse 24 (2).png"
                            class="ct_img_60 "
                            alt=""
                          />
                          <div>
                            <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                              James Thornton
                            </h5>
                            <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              data-aos="fade-right"
              data-aos-duration="1500"
              class="ct_looking_for_work_bg ct_looking_for_work_bg_left     ct_p_111_y_106 ct_mt_100"
              style={{ backgroundColor: "var(--orange)" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4">
                    Start your journey today with us.
                  </h4>
                  <p class="mb-0 ct_fs_18 ct_fw_300">
                    We’re built with your feedback and designed to grow with you
                    every step of the way.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  // onClick={() => navigate(coachPaths?.ContactUs)}
                  >
                    View Blog
                  </a>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 pt-0 ct_mt_100">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_about_cnt">
                      <h2 class=" ct_fs_32  ct_mb_60">
                        Frequently asked questions
                      </h2>

                      <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                        <div class="accordion" id="faq_accordionExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faq_one">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_one"
                                aria-expanded="false"
                                aria-controls="collapsefaq_one"
                              >
                                How do I get started as a freelancer on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_one"
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqtwo">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Two"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                What types of projects can I find on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Two"
                              class="accordion-collapse collapse "
                              aria-labelledby="faqtwo"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqthree">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Three"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Three"
                              >
                                How does payment work?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Three"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqthree"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFour">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Four"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Four"
                              >
                                What support does NUVIO provide to freelancers?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Four"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFour"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xxl-5  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_about_img">
                      <img
                        src="../assets/img/pexels-fauxels_456.png"
                        class="ct_img_h_617"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              data-aos="fade-left"
              data-aos-duration="1500"
              class="ct_looking_for_work_bg ct_p_111_y_106 ct_mt_100 ct_mb_100"
              style={{ backgroundColor: "#219EBC" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4">Unlock your potential.</h4>
                  <p class="mb-0 ct_fs_18 ct_fw_300">
                    Join a community of top IT professionals and access
                    high-value projects worldwide.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                    onClick={() => navigate(coachPaths?.WebinarData)}
                  >
                    View Workshop
                  </a>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
    </MenuLayout>
  );
};

export default Freelance;
